module.exports = __webpack_public_path__ + "static/media/masthead-harvey-waroona-reporter.576ae2e3.svg";